import { render } from "./AcessoView.vue?vue&type=template&id=71e15da2&scoped=true"
import script from "./AcessoView.vue?vue&type=script&lang=js"
export * from "./AcessoView.vue?vue&type=script&lang=js"

import "./AcessoView.vue?vue&type=style&index=0&id=71e15da2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e15da2"]])

export default __exports__